<template>
  <div class="thank-you">
    <h1>
      {{ $t('thankYouTitle') }}
    </h1>
    <h3>{{ $t('thankYouMessage') }}</h3>
  </div>
</template>
<style scoped>
.thank-you {
  margin-top: 100px;
}
</style>
